import BusinessCategoriesPage from './BusinessCategoriesPage';

export default BusinessCategoriesPage;
